import { useMediaQuery } from './use-media-query';

/**
 * The one breakpoint that separates the mobile design from the desktop one.
 *
 * Kept in sync with Tailwind's `lg` (64rem = 1024px), which the app shells
 * already use to swap the top nav for the bottom tab bar (`lg:hidden` /
 * `hidden lg:flex`). A JS hook and a CSS breakpoint that disagree would show
 * the mobile chrome around a desktop page (or vice versa) in the gap between
 * them, so this constant is the single source for both sides of the switch.
 */
export const MOBILE_MEDIA_QUERY = '(max-width: 1023.98px)';

/**
 * True when the viewport is in the mobile design's range.
 *
 * Use this to choose which of two genuinely different layout trees to MOUNT —
 * the mobile design is not a reflow of the desktop one (different chrome,
 * different card anatomy), so rendering both and hiding one with CSS would
 * double the DOM and run every chart's layout twice.
 *
 * For a component that merely reflows, prefer Tailwind breakpoints: this hook
 * costs a subscription and returns `false` on the server / first paint.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_MEDIA_QUERY);
}
